// removed by extract-text-webpack-plugin
module.exports = {"icon":"src-components-modules-Feature-style----icon-module---icon---Iqgnp alignItems-center borderRadius-circle display-flex fill-white justifyContent-center marginBottom-m"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Feature/style/icon.module.css
// module id = 1452
// module chunks = 168707334958949